<template>
  <div class="match-guide">
    <div class="guide-top" :class="coachData.isListen && 'guide-top-not'">
      <div class="guide-info">
        <participant-carousel />
        <div class="guide-info-right" @click="editUserInfo">编辑个人信息</div>
      </div>
      <div class="guide-hear" v-if="!coachData.isListen">
        <img class="guide-top-title1" src="../../assets/matchGuide/title1.png" alt="" />
        <div class="guide-top-text">
          <div>1v6小班直播试听课，</div>
          <div>提升创意绘画技巧，</div>
          <div>助力宝贝抱奖而归！</div>
        </div>
        <img
          class="guide-top-btn"
          src="../../assets/matchGuide/zero_btn.png"
          alt=""
          @click="showConfirmDialog"
        />
      </div>
    </div>
    <div class="guide-title" :class="coachData.isListen && 'top'">
      <img class="guide-title-img" src="../../assets/matchGuide/title2.png" alt="" />
    </div>
    <div class="guide-course">
      <div class="guide-course-item" v-for="(item, index) in courseList" :key="index">
        <img class="guide-course-item-bg" :src="item.src" alt="" />
        <div class="guide-course-video">
          <video-player
            :key="coachData[item.attribute] + index"
            :cover-url="item.coverUrl"
            :diy-play-btn="true"
            :video-url="'/static' + coachData[item.attribute]"
          />
        </div>
        <div v-if="!index">
          <div class="guide-course-shape0"></div>
          <div class="guide-course-shape00"></div>
        </div>
        <div v-else :class="`guide-course-shape${index}`"></div>
      </div>
    </div>

    <!-- 报名弹窗 -->
    <sign-dialog ref="SignDialog" @jumpLogin="jumpPersonInfo" />
    <!-- 确认弹窗 -->
    <confirm-dialog ref="ConfirmDialog" @successSignup="queryList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommonLoginSDK from '@i61/common-login'
import { getCompetitionGuidance } from '../../api/matchGuide'
import { PERSON_INFO_ROUTE } from '../../constant'
import SignDialog from './dialog/signDialog'
const courseList = [
  {
    src: require('paintingCompetition/assets/matchGuide/course1.png'),
    coverUrl: require('paintingCompetition/assets/matchGuide/course1_cover.jpg'),
    attribute: 'hotPotVideo'
  },
  {
    src: require('paintingCompetition/assets/matchGuide/course2.png'),
    coverUrl: require('paintingCompetition/assets/matchGuide/course2_cover.jpg'),
    attribute: 'sugarVideo'
  },
  {
    src: require('paintingCompetition/assets/matchGuide/course3.png'),
    coverUrl: require('paintingCompetition/assets/matchGuide/course3_cover.jpg'),
    attribute: 'cityVideo'
  },
  {
    src: require('paintingCompetition/assets/matchGuide/course4.png'),
    coverUrl: require('paintingCompetition/assets/matchGuide/course4_cover.jpg'),
    attribute: 'brothersVideo'
  }
]
Object.freeze(courseList)

export default {
  name: 'MatchGuide',
  components: {
    SignDialog,
    // 播放器
    VideoPlayer: () => import('paintingCompetition/components/VideoPlayer'),
    // 确认弹窗
    ConfirmDialog: () => import('paintingCompetition/components/InfoConfirmDialog'),
    ParticipantCarousel: () => import('paintingCompetition/components/ParticipantCarousel')
  },
  computed: {
    ...mapState(['basicData', 'isLogged', 'ownerUserInfo'])
  },
  data() {
    return {
      coachData: {
        // https://www.runoob.com/try/demo_source/movie.mp4
        // 音频-三结义
        brothersVideo: '',
        // 音频-白帝城
        cityVideo: '',
        // 音频-火锅池
        hotPotVideo: '',
        // 音频-糖人
        sugarVideo: '',
        // 是否报名
        isSignUp: 0,
        // 是否试听
        isListen: 0
      },
      courseList
    }
  },
  mounted() {
    this.initData()
    this.buryPoint()
  },
  methods: {
    initData() {
      if ((!this.isLogged || !this.basicData.isSignUp) && this.basicData.state === 1) {
        this.showSignUpDialog()
      }
      this.queryList()
    },
    queryList() {
      this.$toast.loading({
        message: '加载中',
        forbidClick: true,
        overlay: true
      })
      getCompetitionGuidance({ userId: this.ownerUserInfo.userId }).then(res => {
        if (res.code === 0) {
          this.coachData = res.data
        }
        this.$toast.clear()
      })
    },
    editUserInfo() {
      this.fancyRouterPush({ path: PERSON_INFO_ROUTE })
    },
    jumpLogin() {
      CommonLoginSDK.loginHandle()
    },
    jumpPersonInfo() {
      this.fancyRouterPush({ path: PERSON_INFO_ROUTE })
    },
    showConfirmDialog() {
      this.$refs.ConfirmDialog.show(this.coachData)
    },
    showSignUpDialog() {
      this.$refs.SignDialog.show()
    },
    buryPoint() {
      if (this.isLogged && this.basicData.isSignUp) {
        this.recordLog({
          eventName: 'PaintChina_Tutorial_page',
          properties: {
            eventId: '赛事辅导课页',
            label: '显示赛事辅导课页（已报名未参赛/已参赛）'
          }
        })
      } else {
        this.recordLog({
          eventName: 'PaintChina_Tutorial_Tourist_page',
          properties: {
            eventId: '赛事辅导课页',
            label: '显示赛事辅导课页（游客）'
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/var.scss';
.match-guide {
  background-color: $backGroundColor;
}

.guide-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 467px;
  background: url('~paintingCompetition/assets/matchGuide/title_bg.png') no-repeat;
  background-size: 100% auto;
  &.guide-top-not {
    height: auto;
    background: none;
  }
  .guide-info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 28px 38px 28px;
    box-sizing: border-box;
    &-right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 183px;
      height: 48px;
      background: rgba(1, 19, 110, 0.4);
      border-radius: 24px;
      color: #ffffff;
      font-size: 24px;
      white-space: nowrap;
    }
  }
  .guide-hear {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-title1 {
    width: 641px;
  }
  &-text {
    margin: 22px 0 0 25px;
    text-align: center;
    font-size: 32px;
    color: #323bb5;
    font-weight: 600;
    line-height: 41px;
  }
  &-btn {
    width: 352.2px;
    height: 107.3px;
    margin: 30px 0 0 8px;
    animation: breathe 0.8s linear infinite;
  }
}

.guide-title {
  padding: 54px 0 59px 0;
  &.top {
    padding-top: 0;
  }
  &-img {
    display: block;
    width: 641px;
    height: 97px;
    margin: 0 auto;
  }
}

.guide-course {
  .guide-course-item {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 726px;
    height: 484px;
    margin: 0 auto;
    padding-bottom: 51px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    &-bg {
      position: absolute;
      z-index: 1;
      width: 100%;
    }
  }
  .guide-course-video {
    position: relative;
    width: 660px;
    height: 380px;
    margin: 65px 0 0 2px;
    z-index: 2;
  }
  .guide-course-play {
    width: 100px;
    height: 101px;
    margin-top: 40px;
  }
  .guide-course-shape0 {
    position: absolute;
    right: -12px;
    top: -95px;
    width: 38.5px;
    height: 173px;
    background: url('~paintingCompetition/assets/matchGuide/shape1.png') no-repeat;
    background-size: 100% auto;
  }
  .guide-course-shape00 {
    position: absolute;
    left: -12px;
    top: 61px;
    width: 48px;
    height: 223px;
    background: url('~paintingCompetition/assets/matchGuide/shape2.png') no-repeat;
    background-size: 100% auto;
  }
  .guide-course-shape1 {
    position: absolute;
    right: -12px;
    top: 123px;
    width: 31.3px;
    height: 192px;
    background: url('~paintingCompetition/assets/matchGuide/shape3.png') no-repeat;
    background-size: 100% auto;
  }
  .guide-course-shape2 {
    position: absolute;
    left: -12px;
    top: 93px;
    width: 60.8px;
    height: 207px;
    background: url('~paintingCompetition/assets/matchGuide/shape4.png') no-repeat;
    background-size: 100% auto;
  }
  .guide-course-shape3 {
    position: absolute;
    right: -12px;
    top: 98px;
    width: 42px;
    height: 223px;
    background: url('~paintingCompetition/assets/matchGuide/shape5.png') no-repeat;
    background-size: 100% auto;
  }
}
</style>
